import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Tag, Modal, Input, AutoComplete, Spin, Alert } from 'antd'
import styled from 'styled-components'

import Button from 'components/Button'
import Drawer from 'components/Drawer'
import CheckIconWhite from 'components/icons/CheckIconWhite'
import { FlexWrap } from 'components/UIComponents/FormStyles'
import {
  getListOfCity,
  getListOfCounties,
  getListOfState,
} from 'modules/Onboarding/actions'
import { Form } from './Style/style'
import { searchConfig } from 'utils/config'
import { getMasterSearchApi } from '../../../../../Onboarding/actions'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { crawlInstituteUrl, searchCollegeInDatabase, fetchCollegeCourses } from './webCrawlerAPI'
import { getDegreeData } from 'modules/Courses/actions'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import elasticSearchSyncRequest from 'utils/elasticSearchSyncRequest'
import instituteRequest from 'utils/instituteRequest'
import ContactInstituteDetails from './ContactInstituteDetails'
import InstitutesDetails from './InstituteDetails'
const { COUNTRY_ID } = process.env

// Tighter vertical rhythm for the Add College drawer form
const CompactWrap = styled.div`
  .ant-form-item {
    margin-bottom: 10px;
  }
  .ant-form-item-label {
    padding-bottom: 2px;
  }
  .ant-form-item-label > label {
    font-size: 13px;
  }
`

const AddNewCollegeDrawer = ({
  newInstituteDrawer,
  setNewInstituteDrawer,
  formId = 'institute_form',
  title = 'Add Institutes',
  sendButtonText = 'Add',
  dateFormat,
  isSystemConfig = false,
  universityValue,
  handleSubmitCongif,
  view = false,
  setView,
  addContent,
  form,
  universityId,
  setUniversityId,
}) => {
  const [searchCountry, setSearchCountry] = useState('')
  const [crawlLoading, setCrawlLoading] = useState(false)
  const [crawledCourses, setCrawledCourses] = useState([])
  const [fallbackModalVisible, setFallbackModalVisible] = useState(false)
  const [fallbackForm, setFallbackForm] = useState({ collegeName: '', city: '', state: '' })
  const [fallbackLoading, setFallbackLoading] = useState(false)
  const [fallbackMatches, setFallbackMatches] = useState([])
  const [fallbackFetching, setFallbackFetching] = useState(false)
  const [resolvedCourses, setResolvedCourses] = useState([])
  const [existingCollegeInfo, setExistingCollegeInfo] = useState(null)
  const [confirmingExisting, setConfirmingExisting] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const dispatch = new useDispatch()

  // Careers360's search API has no per-city/state filter, so City/State
  // narrow the already-fetched match list live as the user types, rather
  // than requiring another round-trip search.
  const filteredFallbackMatches = useMemo(() => {
    const cityNeedle = fallbackForm.city?.trim().toLowerCase()
    const stateNeedle = fallbackForm.state?.trim().toLowerCase()
    return fallbackMatches.filter(m => {
      if (cityNeedle && !m.city?.toLowerCase().includes(cityNeedle)) return false
      if (stateNeedle && !m.state?.toLowerCase().includes(stateNeedle)) return false
      return true
    })
  }, [fallbackMatches, fallbackForm.city, fallbackForm.state])

  useEffect(() => {
    dispatch(getListOfCounties())
  }, [])

  useEffect(() => {
    let payLoad = { ...searchConfig.universities, q: '' }
    dispatch(getMasterSearchApi('universities', payLoad))
  }, [])

  const countryList = useSelector(state => state?.CorporateData?.countryList)
  const universityList = useSelector(
    state => state?.CorporateData?.masterSearchApi
  )
  const [countryCode, setCountryCode] = useState('+91')
  const [stateList, setStateList] = useState([])
  const [cityList, setCityList] = useState([])
  const [countryName, setCountryName] = useState('')
  const [stateName, setStateName] = useState('')
  const [cityName, setCityName] = useState('')
  const [countryId, setCountryId] = useState('')
  const [stateId, setStateId] = useState('')
  const [cityId, setPermCityId] = useState('')
  const [universityName, setUniversityName] = useState('')
  const [loadingCountry, setLoadingCountry] = useState(false)
  const [loadingState, setLoadingState] = useState(false)
  const [loadingCity, setLoadingCity] = useState(false)

  let getStateData = async (countryId, isSate, search) => {
    if (countryId) {
      setLoadingState(true)
      let list = await dispatch(getListOfState(countryId, search))
      setLoadingState(false)
      return setStateList(list || [])
    }
  }

  let getCityData = async (countryId, stateId, isSate, search) => {
    if (countryId && stateId) {
      setLoadingCity(true)
      let list = await dispatch(getListOfCity(countryId, stateId, search))
      setLoadingCity(false)
      return setCityList(list || [])
    }
  }

  useEffect(() => {
    let getData
    getData = setTimeout(() => {
      setLoadingCountry(true)
      dispatch(getListOfCounties(searchCountry))
      setLoadingCountry(false)
    }, 500)
    return () => clearTimeout(getData)
  }, [searchCountry])

  const onStateChange = (data, option) => {
    form.setFieldsValue({
      state: data,
      city: '',
      stateId: option?.option?._id,
      cityId: '',
    })
    setStateName(data)
    setStateId(option?.option?._id)
    setCityName('')
    getStateData(countryId, true)
    getCityData(countryId, option?.option?._id, true)
  }

  const onCityChange = (data, option) => {
    form.setFieldsValue({
      city: data,
      cityId: option?.option?._id,
    })
    setCityName(data)
    setPermCityId(option?.option?._id)
    getCityData(countryId, stateId, true)
  }

  const onCountryChange = (data, option) => {
    form.setFieldsValue({
      country: data,
      state: '',
      city: '',
      countryId: option?.option?._id,
      stateId: '',
      cityId: '',
    })
    setCountryName(data)
    setCountryId(option?.option?._id)
    setStateName('')
    setStateId('')
    setCityName('')
    setSearchCountry('')
    getStateData(option?.option?._id, true)
  }

  // Country/State/City selects render from local `countryId`/`stateName`/`cityName`
  // state (see InstituteDetails: e.g. State's displayed value is gated on the
  // `countryId` prop, City's on `form state` field) — form.setFieldsValue alone
  // never unlocks or displays them. This crawler flow only targets Indian
  // colleges, so Country always resolves to India; State/City are resolved via
  // the search-scoped list endpoints (not the stale, differently-scoped
  // cityList/stateList already in local state) before patching the form.
  const populateLocation = async (patch, data) => {
    const indiaName = countryList.find(c => c._id === COUNTRY_ID)?.name || 'India'
    patch.country = indiaName
    patch.countryId = COUNTRY_ID
    setCountryName(indiaName)
    setCountryId(COUNTRY_ID)

    if (!data?.addressState) return

    const states = (await dispatch(getListOfState(COUNTRY_ID, data.addressState))) || []
    setStateList(states)
    const needleState = data.addressState.toLowerCase()
    const state = states.find(s => s.name?.toLowerCase() === needleState) || states[0]
    if (!state) return

    patch.state = state.name
    patch.stateId = state._id
    setStateName(state.name)
    setStateId(state._id)

    if (!data?.addressCity) return

    const cities = (await dispatch(getListOfCity(COUNTRY_ID, state._id, data.addressCity))) || []
    setCityList(cities)
    const needleCity = data.addressCity.toLowerCase()
    const city = cities.find(c => c.name?.toLowerCase() === needleCity) || cities[0]
    if (!city) return

    patch.city = city.name
    patch.cityId = city._id
    setCityName(city.name)
    setPermCityId(city._id)
  }

  const suggestRoleFromEmail = email => {
    if (!email || typeof email !== 'string') return null
    const prefix = email.split('@')[0]?.toLowerCase() || ''
    if (prefix.includes('principal')) return 'Principal'
    if (prefix.includes('director')) return 'Director'
    if (prefix.includes('admin')) return 'Administrator'
    if (prefix.includes('coordinator')) return 'Coordinator'
    if (prefix.includes('manager')) return 'Manager'
    if (prefix.includes('contact')) return 'Contact Person'
    return null
  }

  const handleGetData = async () => {
    let website = form.getFieldValue('website')?.trim()
    if (!website) {
      ErrorMessage('Please enter a website URL first')
      return
    }
    if (!/^https?:\/\//i.test(website)) website = `https://${website}`
    form.setFieldsValue({ website })
    // Reset results of any previous crawl in this drawer session
    setExistingCollegeInfo(null)
    setConfirmingExisting(false)
    setCrawledCourses([])
    setResolvedCourses([])
    setCrawlLoading(true)
    try {
      const data = await crawlInstituteUrl(website)
      const patch = {}

      if (data?.name) {
        let cleanName = data.name
          .replace(/\s*\([^)]*\)\s*/g, '') // remove parentheses
          .split(/\s*[|—–-]\s*/)[0] // split by separators and take first part
          .replace(/\s+(was|is|are)\s+.*/i, '') // remove verb phrases (was established, is located, etc.)
          .trim()
        patch.name = cleanName
        patch.shortName = cleanName.split(/\s+/).map(w => w[0]?.toUpperCase() || '').join('')
      }

      if (data?.address) patch.addressLine1 = data.address
      if (data?.addressCampus) patch.campusLocation = data.addressCampus
      await populateLocation(patch, data)
      if (data?.addressPincode) patch.postalCode = data.addressPincode
      if (data?.email) patch.contactEmail = data.email
      if (data?.secondaryEmail) patch.secondaryContactEmail = data.secondaryEmail
      if (data?.phone?.[0]) patch.contactNumber = data.phone[0]
      if (data?.phone?.[1]) patch.secondaryContactNumber = data.phone[1]
      if (data?.contactPersonName) patch.contactPerson = data.contactPersonName
      if (data?.email && !data?.contactPersonName) {
        const suggestedRole = suggestRoleFromEmail(data.email)
        if (suggestedRole) patch.contactPersonRole = suggestedRole
      }

      const hasData = data?.name || data?.address || data?.email || data?.phone?.length > 0
      if (!hasData) {
        setFallbackModalVisible(true)
        return
      }

      form.setFieldsValue(patch)

      // Check if this college already exists in the system
      let existingCampusId = null
      if (patch.name || data?.name) {
        const existing = await checkExistingCollege(patch.name || data.name, website)
        existingCampusId = existing?.instituteCampus?.[0]?.id
        if (existingCampusId) {
          setExistingCollegeInfo({ campusId: existingCampusId, name: existing.name })
          setConfirmingExisting(true)
        }
      }

      if (data?.courses?.length) {
        setCrawledCourses(data.courses)
        const classified = await resolveAndClassify(data.courses, existingCampusId)
        setResolvedCourses(classified)
      }
      SuccessMessage('Website data fetched successfully')
    } catch {
      setFallbackModalVisible(true)
    } finally {
      setCrawlLoading(false)
    }
  }

  const closeFallbackModal = () => {
    setFallbackModalVisible(false)
    setFallbackForm({ collegeName: '', city: '', state: '' })
    setFallbackMatches([])
  }

  const handleFallbackSearch = async () => {
    if (!fallbackForm.collegeName?.trim()) {
      ErrorMessage('Please enter a college name')
      return
    }

    setFallbackLoading(true)
    setFallbackMatches([])
    try {
      const matches = await searchCollegeInDatabase(
        fallbackForm.collegeName.trim(),
        fallbackForm.city?.trim(),
        fallbackForm.state?.trim()
      )
      if (!matches.length) {
        ErrorMessage('No matching colleges found — try a different name')
        return
      }
      setFallbackMatches(matches)
    } catch (err) {
      ErrorMessage(err?.message || 'Failed to search college')
    } finally {
      setFallbackLoading(false)
    }
  }

  const handleSelectMatch = async match => {
    setFallbackFetching(true)
    try {
      const data = await fetchCollegeCourses(match)
      const patch = {}

      if (data?.name) {
        patch.name = data.name
        patch.shortName = data.name.split(/\s+/).map(w => w[0]?.toUpperCase() || '').join('')
      }
      await populateLocation(patch, data)

      form.setFieldsValue(patch)

      // Check if this college already exists in the system. Skip the separate
      // "College Already Exists" confirm modal here — the Add College drawer's
      // own "already onboarded" banner + Sync Courses button already covers it.
      let existingCampusId = null
      if (data?.name) {
        const existing = await checkExistingCollege(data.name, null)
        existingCampusId = existing?.instituteCampus?.[0]?.id
        if (existingCampusId) {
          setExistingCollegeInfo({ campusId: existingCampusId, name: existing.name })
        }
      }

      if (data?.courses?.length) {
        setCrawledCourses(data.courses)
        const classified = await resolveAndClassify(data.courses, existingCampusId)
        setResolvedCourses(classified)
        SuccessMessage(`${data.courses.length} course(s) found for ${match.title}`)
      } else {
        SuccessMessage('College selected — no courses listed on Careers360')
      }

      closeFallbackModal()
    } catch (err) {
      ErrorMessage(err?.message || 'Failed to fetch college courses')
    } finally {
      setFallbackFetching(false)
    }
  }

  const onUniversityChange = (data, option) => {
    setUniversityId(option?.option?.id)
    setUniversityName(data)
    form.setFieldsValue({ universityName: data })
    let payLoad = { ...searchConfig.universities, q: '' }
    dispatch(getMasterSearchApi('universities', payLoad))
  }

  const onClear = () => {
    setNewInstituteDrawer(false)
    setUniversityName('')
    setCrawledCourses([])
    setResolvedCourses([])
    setExistingCollegeInfo(null)
    setConfirmingExisting(false)
    if (isSystemConfig) {
      form.resetFields()
      setView(false)
    } else {
      form.resetFields()
    }
  }
  const checkExistingCollege = async (name, website) => {
    if (!name) return null
    try {
      // Strip parenthetical abbreviations e.g. "VDPC College (VDPC)" → "VDPC College"
      const cleanName = name.replace(/\s*\([^)]*\)\s*/g, '').trim()
      const searchTerm = cleanName || name
      const res = await elasticSearchRequest({
        method: 'get',
        url: `/institutes/crud/college?pageLimit=20&pageNo=0&search=${encodeURIComponent(searchTerm.toLowerCase())}`,
      })
      const list = res?.data?.data?.result || []
      const nameLower = name.toLowerCase().trim()
      const cleanLower = cleanName.toLowerCase().trim()
      // 1. Exact match on full name
      let match = list.find(c => c.name?.toLowerCase().trim() === nameLower)
      // 2. Exact match on stripped name (abbreviation removed)
      if (!match) match = list.find(c => c.name?.toLowerCase().trim() === cleanLower)
      // 3. Contains match — existing college name is a substring or vice versa
      if (!match) {
        match = list.find(c => {
          const en = c.name?.toLowerCase().trim() || ''
          return en.length >= 8 && (cleanLower.includes(en) || en.includes(cleanLower))
        })
      }
      // 4. Website domain fallback
      if (!match && website) {
        const domain = website.replace(/^https?:\/\/(www\.)?/, '').split('/')[0].toLowerCase()
        match = list.find(c => {
          const w = c.instituteCampus?.[0]?.website || ''
          const d = w.replace(/^https?:\/\/(www\.)?/, '').split('/')[0].toLowerCase()
          return d && d === domain
        })
      }
      return match || null
    } catch {
      return null
    }
  }

  const getDegreeTypeFromName = degreeName => {
    const n = degreeName.toLowerCase()
    if (n.includes('pg diploma') || n.includes('p.g. diploma') || n.includes('post graduate diploma')) return 'P_G_DIPLOMA'
    if (n.includes('diploma')) return 'DIPLOMA'
    if (n.includes('ph.d') || n.includes('phd') || n.includes('doctorate')) return 'PHD'
    if (n.includes('m.tech') || n.includes('mtech') || n.includes('m.e') || n.includes('m.sc') || n.includes('mca') || n.includes('master') || n.includes('mba')) return 'PG'
    return 'UG'
  }

  const autoCreateDegreeStreamMap = async (streamName, degreeId, degreeType) => {
    try {
      const today = new Date().toISOString().slice(0, 10)
      // Find or create the stream
      const searchRes = await instituteRequest.get(
        `/institutes/crud/streams?pageLimit=20&pageNo=0&search=${encodeURIComponent(streamName.toLowerCase())}`
      )
      const existing = (searchRes?.data?.data?.result || []).find(
        s => s.name?.toLowerCase() === streamName.toLowerCase()
      )
      let streamId = existing?.id
      if (!streamId) {
        const createRes = await instituteRequest.post('/institutes/crud/streams', { name: streamName })
        streamId = createRes?.data?.data?.id
        if (!streamId) return null
        await elasticSearchSyncRequest.post('/sync/institute_streams', { query_date: today })
      }
      // Create degree_stream_map
      await instituteRequest.post('/institutes/crud/degree/dept', {
        degreeStreamMap: { degreeId, streamId, duration: 3, examType: 'SEMESTER' },
      })
      await elasticSearchSyncRequest.post('/sync/crud_degree_department', { query_date: today })
      // Re-fetch to get the new degreeStreamMapId
      const fresh = await dispatch(getDegreeData('', degreeType))
      const freshMaps = (fresh?.result || []).flatMap(d => (d.degreeStreamMap || []).map(m => ({ ...m })))
      const newEntry = freshMaps.find(m => m.stream?.id === streamId || m.streamId === streamId)
      return newEntry?.id || null
    } catch {
      return null
    }
  }

  const resolveAndClassify = async (courses, campusId) => {
    const resolved = await resolveCrawledCourses(courses)
    // Mark courses already mapped to the existing campus
    let existingIds = new Set()
    if (campusId) {
      try {
        const res = await instituteRequest.get(`/institutes/instituteCampus/${campusId}/courses?pageLimit=100&pageNo=0`)
        const list = res?.data?.data?.courses || []
        list.forEach(c => { if (c.degreeStreamMapId) existingIds.add(c.degreeStreamMapId) })
      } catch { /* treat all as new */ }
    }
    return resolved.map(r => {
      if (!r.degreeStreamMapId) return { ...r, exists: false, unmatched: true }
      return { ...r, exists: existingIds.has(r.degreeStreamMapId), unmatched: false }
    })
  }

  const resolveCrawledCourses = async courses => {
    // Fetch all unique degree types needed in parallel
    const degreeTypes = [...new Set(courses.map(c => getDegreeTypeFromName(c.degree)))]
    const degreeDataByType = {}
    await Promise.all(degreeTypes.map(async t => {
      degreeDataByType[t] = await dispatch(getDegreeData('', t))
    }))
    // Build a single flat map across all fetched degree types
    const allMaps = []
    for (const [type, data] of Object.entries(degreeDataByType)) {
      for (const deg of (data?.result || [])) {
        for (const m of (deg.degreeStreamMap || [])) {
          allMaps.push({ ...m, degreeId: deg.id, fetchedDegreeType: type })
        }
      }
    }
    // First pass: match each course only within its OWN degree type's maps —
    // stream names (e.g. "Computer Engineering") routinely exist under both
    // B.Tech and Diploma, so matching across all types risks a B.Tech course
    // silently landing on a Diploma degreeStreamMapId (and vice versa).
    const firstPass = courses.map(course => {
      const wantedType = getDegreeTypeFromName(course.degree)
      const needle = course.stream.toLowerCase()
      const candidates = allMaps.filter(m => m.fetchedDegreeType === wantedType)
      const match = candidates.find(m => {
        const sn = (m.stream?.name || '').toLowerCase()
        return sn === needle || sn.includes(needle) || (needle.length >= 5 && needle.includes(sn))
      })
      return { course, wantedType, match }
    })
    // Determine the best default degree PER degree type, from matched courses of that type
    const degreeFreqByType = {}
    for (const { wantedType, match } of firstPass) {
      if (!match) continue
      degreeFreqByType[wantedType] = degreeFreqByType[wantedType] || {}
      degreeFreqByType[wantedType][match.degreeId] = (degreeFreqByType[wantedType][match.degreeId] || 0) + 1
    }
    const topDegreeIdByType = {}
    for (const [type, freq] of Object.entries(degreeFreqByType)) {
      topDegreeIdByType[type] = Object.entries(freq).sort(([, a], [, b]) => b - a)[0]?.[0]
    }
    const resolved = []
    for (const { course, wantedType, match } of firstPass) {
      if (match) {
        resolved.push({ ...course, degreeStreamMapId: match.id })
      } else {
        // No matched course of this exact degree type to infer a dominant degree from —
        // fall back to the first fetched degree of that same type (never a different one)
        const degreeIdForType = topDegreeIdByType[wantedType]
          || (degreeDataByType[wantedType]?.result || [])[0]?.id
        if (degreeIdForType) {
          const newId = await autoCreateDegreeStreamMap(course.stream, degreeIdForType, wantedType)
          resolved.push({ ...course, degreeStreamMapId: newId || null })
        } else {
          resolved.push({ ...course, degreeStreamMapId: null })
        }
      }
    }
    // Deduplicate by degreeStreamMapId
    const seen = new Set()
    return resolved.filter(r => {
      if (!r.degreeStreamMapId) return true
      if (seen.has(r.degreeStreamMapId)) return false
      seen.add(r.degreeStreamMapId)
      return true
    })
  }

  const mapCrawledCourses = async campusId => {
    // Prefer the already-classified list (respects the user's "×" removals and
    // skips greyed-out existing courses); fall back to resolving fresh.
    const resolved = resolvedCourses.length
      ? resolvedCourses.filter(r => !r.exists)
      : await resolveCrawledCourses(crawledCourses)
    const candidates = resolved.filter(r => r.degreeStreamMapId)
    if (!candidates.length) {
      ErrorMessage('No crawled courses could be matched to the degree catalog')
      return
    }
    // Fresh fetch of existing mappings to avoid "already exists" errors
    let existingIds = new Set()
    try {
      const res = await instituteRequest.get(`/institutes/instituteCampus/${campusId}/courses?pageLimit=100&pageNo=0`)
      const list = res?.data?.data?.courses || []
      list.forEach(c => { if (c.degreeStreamMapId) existingIds.add(c.degreeStreamMapId) })
    } catch { /* if fetch fails, submit all and let server deduplicate */ }
    const toMap = candidates.filter(r => !existingIds.has(r.degreeStreamMapId))
    if (!toMap.length) {
      ErrorMessage('All crawled courses are already mapped to this college')
      return
    }
    const payload = toMap.map(r => ({ degreeStreamMapId: r.degreeStreamMapId }))
    try {
      const res = await instituteRequest.post(`/institutes/instituteCampus/${campusId}/courses`, payload)
      const alreadyExist = res?.data?.error?.alreadyEXistRecords?.length || 0
      const added = payload.length - alreadyExist
      if (added > 0) SuccessMessage(`${added} course(s) mapped to institute`)
      else ErrorMessage('All crawled courses already exist for this college')
      // The Course Mapping page reads from the ES alias institute_campus_course_alias
      // (or the PG MV mv_institute_campus_course), not institute.courses directly —
      // without this sync the new mappings are invisible there. Best-effort.
      try {
        const today = new Date().toISOString().slice(0, 10)
        await elasticSearchSyncRequest.post('/sync/institute_campus_cources', { query_date: today })
      } catch (syncErr) {
        console.error('[mapCrawledCourses] ES sync failed:', syncErr?.message)
      }
    } catch (err) {
      ErrorMessage(err?.response?.data?.message || 'Failed to map courses — please try again')
    }
  }

  const FIELD_LABELS = {
    website: 'Website',
    universityName: 'University Name',
    name: 'Institute Name',
    tier: 'Tier',
    ranking: 'Ranking',
    addressLine1: 'Address Line 1',
    campusLocation: 'Campus Location',
    country: 'Country',
    state: 'State',
    city: 'City',
    postalCode: 'Zipcode',
    contactPerson: 'Contact Person Name',
    contactPersonRole: 'Role',
    contactNumber: 'College Number',
    contactEmail: 'Email ID',
  }

  const onSubmitFormFailed = ({ errorFields }) => {
    const fields = errorFields.map(f => FIELD_LABELS[f.name?.[0]] || f.name?.[0])
    ErrorMessage(`Cannot save — please fix: ${fields.join(', ')}`)
  }

  const onSubmitFormData = async formData => {
  setSubmitLoading(true)

  try {
    // College already exists — refresh course mappings only
    if (existingCollegeInfo?.campusId) {
      if (!crawledCourses?.length) {
        ErrorMessage('No courses were crawled for this college')
        onClear()
        return
      }

      await mapCrawledCourses(existingCollegeInfo.campusId)
      onClear()
      return
    }

    let instituteDetails = {
      institute: {
        name: formData.name,
        tier: formData.tier,
        ranking: formData.ranking,
        universityId: universityId,
        university: formData.universityName,
      },
      instituteCampus: {
        campusName: formData.name,
        pilRecommended: formData.pilRecommended,
        isNgo: Boolean(formData.isNgo),
        campusLocation: formData.campusLocation,
        addressLine1: formData.addressLine1,
        postalCode: formData.postalCode,
        website: formData.website,
        contactPerson: formData.contactPerson,
        contactPersonRole: formData.contactPersonRole,
        contactNumber: formData.contactNumber,
        secondaryContactNumber: formData.secondaryContactNumber,
        contactEmail: formData.contactEmail,
        secondaryContactEmail: formData.secondaryContactEmail,
        city: formData.city,
        state: formData.state,
        cityId: cityId,
        stateId: stateId,
        country: formData.country,
        countryId: countryId,
        countryCode: countryCode,
        shortName: formData.shortName,
      },
    }

    const result = await handleSubmitCongif(instituteDetails, 'post')

    const campusId = result?.data?.data?.instituteCampus?.[0]?.id

    if (crawledCourses?.length && campusId) {
      await mapCrawledCourses(campusId)
    }

    setCrawledCourses([])
    setResolvedCourses([])
    setExistingCollegeInfo(null)
    setConfirmingExisting(false)
    setNewInstituteDrawer(false)
    setUniversityName('')
  } finally {
    setSubmitLoading(false)
  }
}

  useEffect(() => {
    if (addContent) {
      form.resetFields()
      getCityData('', '', true)
      form.setFieldsValue({
        name: '',
        website: '',
        country: '',
        state: '',
        stateId: '',
        cityId: '',
        city: '',
      })
      setStateName('')
      setStateId('')
      getStateData(COUNTRY_ID, true)
    } else if (universityValue) {
      setCountryName(universityValue?.instituteCampus?.[0]?.country)
      setCountryId(universityValue?.instituteCampus?.[0]?.countryId)
      setStateName(universityValue?.instituteCampus?.[0]?.state)
      setStateId(universityValue?.instituteCampus?.[0]?.stateId)
      setCityName(universityValue?.instituteCampus?.[0]?.city)
      setPermCityId(universityValue?.instituteCampus?.[0]?.cityId)
      getStateData(universityValue?.instituteCampus?.[0]?.countryId, true)
      getCityData(
        universityValue?.instituteCampus?.[0]?.countryId,
        universityValue?.instituteCampus?.[0]?.stateId,
        true
      )
    }
  }, [universityValue, newInstituteDrawer, addContent])
  function handleKeyPress() {}

  const content = () => {
    return (
      <CompactWrap style={{ pointerEvents: view ? 'none' : '' }}>
        <Modal
          open={confirmingExisting}
          title="College Already Exists"
          okText="Yes, Sync Courses"
          cancelText="No, Save as New College"
          onOk={() => setConfirmingExisting(false)}
          onCancel={async () => {
            setExistingCollegeInfo(null)
            setConfirmingExisting(false)
            // Re-resolve courses without campusId so they all show as "new"
            if (crawledCourses.length) {
              const reclassified = await resolveAndClassify(crawledCourses, null)
              setResolvedCourses(reclassified)
            }
          }}
        >
          <p>
            <strong>{existingCollegeInfo?.name}</strong> already exists in the system.
          </p>
          <p>
            Do you want to refresh its course mappings from the crawled data?
          </p>
        </Modal>
        {existingCollegeInfo && !confirmingExisting && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 12 }}
            message={`College already onboarded: ${existingCollegeInfo.name}`}
            description="Clicking 'Sync Courses' will only add new course mappings from the crawled data — the college record will not be modified."
          />
        )}
        <Form
          scrollToFirstError
          onFinish={onSubmitFormData}
          onFinishFailed={onSubmitFormFailed}
          id={formId}
          form={form}
          layout="vertical"
          autoComplete="off"
        >
          <InstitutesDetails
            cityList={cityList}
            countryList={countryList}
            stateList={stateList}
            dateFormat={dateFormat}
            onCountryChange={onCountryChange}
            countryValue={countryName}
            stateValue={stateName}
            cityValue={cityName}
            countryId={countryId}
            stateId={stateId}
            getStateData={getStateData}
            getCityData={getCityData}
            setSearchCountry={setSearchCountry}
            onStateChange={onStateChange}
            onCityChange={onCityChange}
            isSystemConfig={true}
            form={form}
            onKeyPress={handleKeyPress}
            setUniversityName={setUniversityName}
            universityValue={universityName}
            universityList={universityList}
            onUniversityChange={onUniversityChange}
            loadingCountry={loadingCountry}
            loadingState={loadingState}
            loadingCity={loadingCity}
            setLoadingCountry={setLoadingCountry}
            setLoadingState={setLoadingState}
            setLoadingCity={setLoadingCity}
            onGetData={handleGetData}
            crawlLoading={crawlLoading}
          />
          <ContactInstituteDetails
            countryCode={countryCode}
            setCountryCode={setCountryCode}
            form={form}
          />
        </Form>
        {(resolvedCourses.length > 0 || crawledCourses.length > 0) && (
          <div style={{ marginTop: 16, borderTop: '1px solid #f0f0f0', paddingTop: 12 }}>
            <div style={{ fontWeight: 600, marginBottom: 8, fontSize: 13, color: '#555' }}>
              {resolvedCourses.length > 0
                ? `Crawled Courses — ${resolvedCourses.filter(r => !r.exists && !r.unmatched).length} new, ${resolvedCourses.filter(r => r.exists).length} already mapped${resolvedCourses.filter(r => r.unmatched).length > 0 ? `, ${resolvedCourses.filter(r => r.unmatched).length} unmatched` : ''}`
                : `Crawled Courses — ${crawledCourses.length} found`}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {(resolvedCourses.length > 0 ? resolvedCourses : crawledCourses).map((course, i) => (
                <Tag
                  key={`${course.degree}-${course.stream}-${i}`}
                  color={course.exists ? undefined : course.unmatched ? 'warning' : 'blue'}
                  closable={!course.exists}
                  onClose={!course.exists ? e => {
                    e.preventDefault()
                    if (resolvedCourses.length > 0) {
                      setResolvedCourses(prev => prev.filter((_, idx) => idx !== i))
                    } else {
                      setCrawledCourses(prev => prev.filter((_, idx) => idx !== i))
                    }
                  } : undefined}
                  style={{
                    marginBottom: 4,
                    fontSize: 12,
                    opacity: course.exists ? 0.5 : 1,
                  }}
                >
                  {course.degree}{course.stream ? ` — ${course.stream}` : ''}
                  {resolvedCourses.length > 0 && (
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: 11,
                        marginLeft: 4,
                        color: course.exists ? '#888' : course.unmatched ? '#d46b08' : '#1677ff',
                      }}
                    >
                      · {course.exists ? 'mapped' : course.unmatched ? 'unmatched' : 'new'}
                    </span>
                  )}
                </Tag>
              ))}
            </div>
          </div>
        )}
      </CompactWrap>
    )
  }

  const footer = () => {
    return (
      <FlexWrap gap="20px" right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            onClear()
          }}
        />
        <Button.Primary
          htmlType="submit"
          form={formId}
          text={existingCollegeInfo && !confirmingExisting ? 'Sync Courses' : sendButtonText}
          disabled={view} // Disable if view is true or search input is not empty
          loading={submitLoading}
          icon={<CheckIconWhite />}
        />
      </FlexWrap>
    )
  }
  return (
    <>
      <Drawer
        title={title}
        placement="right"
        closable={true}
        onClose={onClear}
        visible={newInstituteDrawer}
        content={content()}
        footer={footer()}
      />
      <Modal
        title="Website Not Found - Search College in Database"
        visible={fallbackModalVisible}
        width={720}
        onCancel={closeFallbackModal}
        footer={
          <FlexWrap gap="12px" right>
            <Button.Secondary text="Cancel" onClick={closeFallbackModal} />
            <Button.Primary
              text={fallbackLoading ? 'Searching...' : 'Search'}
              onClick={handleFallbackSearch}
              disabled={fallbackLoading || fallbackFetching}
            />
          </FlexWrap>
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', paddingTop: '12px' }}>
          <div>
            <label style={{ fontSize: '14px', fontWeight: 600, marginBottom: '6px', display: 'block' }}>
              College Name
            </label>
            <Input
              placeholder="Enter college name"
              value={fallbackForm.collegeName}
              onChange={e => setFallbackForm({ ...fallbackForm, collegeName: e.target.value })}
              onPressEnter={handleFallbackSearch}
            />
          </div>
          <div>
            <label style={{ fontSize: '14px', fontWeight: 600, marginBottom: '6px', display: 'block' }}>
              City <span style={{ fontWeight: 400, color: '#999' }}>(optional)</span>
            </label>
            <AutoComplete
              style={{ width: '100%' }}
              placeholder="Select or type city"
              value={fallbackForm.city}
              options={(cityList || []).map(c => ({ value: c.name }))}
              filterOption={(input, option) =>
                option?.value?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={value => setFallbackForm({ ...fallbackForm, city: value })}
            />
          </div>
          <div>
            <label style={{ fontSize: '14px', fontWeight: 600, marginBottom: '6px', display: 'block' }}>
              State <span style={{ fontWeight: 400, color: '#999' }}>(optional)</span>
            </label>
            <AutoComplete
              style={{ width: '100%' }}
              placeholder="Select or type state"
              value={fallbackForm.state}
              options={(stateList || []).map(s => ({ value: s.name }))}
              filterOption={(input, option) =>
                option?.value?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={value => setFallbackForm({ ...fallbackForm, state: value })}
            />
          </div>
          {fallbackFetching && (
            <div style={{ textAlign: 'center', padding: '12px' }}>
              <Spin /> <span style={{ marginLeft: 8, color: '#888' }}>Fetching courses…</span>
            </div>
          )}
          {!fallbackFetching && fallbackMatches.length > 0 && (
            <div>
              <div style={{ fontWeight: 600, fontSize: 13, color: '#555', margin: '4px 0 8px' }}>
                {filteredFallbackMatches.length} college(s) found — select one to load its courses
              </div>
              <div style={{ maxHeight: 260, overflowY: 'auto', border: '1px solid #f0f0f0', borderRadius: 6 }}>
                {filteredFallbackMatches.map(match => (
                  <div
                    key={match.url}
                    onClick={() => handleSelectMatch(match)}
                    style={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f5f5f5',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#f0f7ff' }}
                    onMouseLeave={e => { e.currentTarget.style.background = '' }}
                  >
                    <div style={{ fontWeight: 600, fontSize: 13 }}>{match.title}</div>
                    <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                      {[match.city, match.state, match.country].filter(Boolean).join(', ') || '—'}
                      <span style={{ float: 'right', color: '#1890ff' }}>{match.source}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  )
}

export default AddNewCollegeDrawer
